import { useQuery } from '@tanstack/react-query';
import { getVendorListAPI } from 'src/api';

export const useGetVendorList = () => {
  return useQuery({
    queryKey: ['vendor-list'],
    queryFn: getVendorListAPI,
    staleTime: 1000 * 60 * 60 * 1, // 1 hour
  });
};
